/**
 * Configuración runtime del frontend.
 *
 * Convención recomendada para CRA:
 * - usar variables `REACT_APP_*`.
 *
 * Compatibilidad:
 * - se conservan fallbacks hardcoded o legacy para no romper despliegues
 *   existentes mientras se migra la configuración a `.env`.
 */
const runtimeConfig = {
  apiBaseUrl:
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    "https://api.mentfull.com",
  publicVapidKey:
    process.env.REACT_APP_PUBLIC_VAPID_KEY ||
    process.env.PUBLIC_VAPID_KEY ||
    "",
  paypalClientId:
    process.env.REACT_APP_PAYPAL_CLIENT_ID ||
    "",
  paypalPlanIds: {
    Basic:
      process.env.REACT_APP_PAYPAL_PLAN_BASIC ||
      "",
    Silver:
      process.env.REACT_APP_PAYPAL_PLAN_SILVER ||
      "",
    Gold:
      process.env.REACT_APP_PAYPAL_PLAN_GOLD ||
      "",
  },
};

export default runtimeConfig;
